<template>
  <div>
    <h1 v-t="'entities.setElement.name_plural'" class="mt-0"></h1>

    <dx-data-grid
      ref="dataGrid"
      :columns="columns"
      :data-source="store"
      :remote-operations="remoteOperations"
      :show-borders="true"
      :show-row-lines="false"
      :show-column-lines="true"
      :row-alternation-enabled="true"
    >
      <dx-editing
        :allow-adding="true"
        :allow-updating="true"
        :allow-deleting="true"
        mode="row"
      />

      <dx-sorting mode="multiple"/>

      <dx-filter-row :visible="true"/>
      <dx-filter-panel :visible="true"/>

      <dx-paging :page-size="15"/>
      <dx-pager
        :allowed-page-sizes="[15, 30, 50]"
        :visible="true"
        :show-info="true"
        :show-navigation-buttons="true"
        :show-page-size-selector="true"
      />
    </dx-data-grid>
  </div>
</template>

<script>
import { DxDataGrid } from 'devextreme-vue';
import {
  DxEditing,
  DxFilterPanel,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxSorting,
} from 'devextreme-vue/data-grid';
import createBackendStore from '@/lib/create-backend-store';
import { buildColumns } from '@/lib/data-grid-columns';

export default {
  name: 'SetElements',
  components: {
    DxDataGrid,
    DxEditing,
    DxFilterRow,
    DxFilterPanel,
    DxPager,
    DxPaging,
    DxSorting,
  },
  data() {
    return {
      store: null,
      columns: this.buildColumns('setElement', [
        {
          property: 'set',
          sortOrder: 'asc',
        },
        {
          property: 'name',
          sortOrder: 'asc',
        },
      ]),
      remoteOperations: {
        paging: true,
        filtering: true,
        sorting: true,
      },
    };
  },
  methods: {
    buildColumns,
    configureStore(columns) {
      const fields = columns
        .map(c => c.dataField)
        .filter(f => f);

      return createBackendStore('/set-elements', { fields });
    },
  },
  created() {
    this.store = this.configureStore(this.columns);
  },
};
</script>

<style scoped>

</style>
